import { Link } from 'react-router'
import { H1 } from '@/components/sv/typographies'
import { SevallaLogo } from '@/logos'

export const NotFound = () => {
  return (
    <div className="flex min-h-[100svh] items-center justify-center p-8">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <SevallaLogo className="w-auto h-10" />
        </div>
        <H1 className="text-3xl font-semibold">Page not found</H1>
        <p className="mt-2 text-muted-foreground">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link to="/" className="text-primary underline">
            Go back home
          </Link>
        </div>
      </div>
    </div>
  )
}
